import React from "react";
import {useTranslation} from "react-i18next";
import DigitalSigningPageTextField from "./DigitalSigningPageTextField";
import {PageTexts} from "./digitalSigningTemplate.util";

interface Props {
    value: PageTexts
    onChange: (value: PageTexts) => void
    errors?: Partial<PageTexts>
    disabled?: boolean
}

/** Thank-you message fields shown to the guest after signing. */
const DigitalSigningThankYouFields = ({value, onChange, errors, disabled}: Props) => {
    const {t} = useTranslation();

    return (
        <DigitalSigningPageTextField
            id={'digital-signing-thank-you'}
            title={t('Message')}
            tooltip={t('Shown for 20 seconds with the animation after the guest signed. Empty: “Thank you for your confirmation.”')}
            value={value}
            onChange={onChange}
            errors={errors}
            multiline
            disabled={disabled}
        />
    );
};

export default DigitalSigningThankYouFields;
